import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-b32ee35c"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "container long-container"
};
var _hoisted_2 = {
  class: "row"
};
var _hoisted_3 = {
  class: "col-md-8 long-left",
  id: "long-left"
};
var _hoisted_4 = ["onClick"];

var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("i", {
    class: "icon-play"
  }, null, -1);
});

var _hoisted_6 = /*#__PURE__*/_createTextVNode(" 播放视频 ");

var _hoisted_7 = [_hoisted_5, _hoisted_6];
var _hoisted_8 = ["src"];
var _hoisted_9 = {
  class: "date"
};
var _hoisted_10 = {
  class: "col-md-4 long-right"
};
var _hoisted_11 = ["onClick"];
var _hoisted_12 = ["src"];
var _hoisted_13 = {
  class: "textarea"
};
var _hoisted_14 = {
  class: "date"
};
var _hoisted_15 = {
  class: "title"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("blockquote", null, [_createElementVNode("h2", null, _toDisplayString($setup.knowledgedetail.title), 1)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.knowledgedetail.content, function (c, index) {
    return _openBlock(), _createElementBlock("div", {
      class: "content-list",
      key: c.contentId
    }, [_createElementVNode("h4", null, [_createTextVNode(_toDisplayString(c.contentTitle) + " ", 1), c.hasVideo ? (_openBlock(), _createElementBlock("span", {
      key: 0,
      class: "video-tag",
      onClick: function onClick($event) {
        return $setup.playVideo(c.videoUrl);
      }
    }, _hoisted_7, 8, _hoisted_4)) : _createCommentVNode("", true)]), _createElementVNode("p", null, _toDisplayString(c.contentText), 1), $setup.showVideo ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: "video-modal",
      onClick: _cache[1] || (_cache[1] = function () {
        return $setup.closeVideo && $setup.closeVideo.apply($setup, arguments);
      })
    }, [_createElementVNode("video", {
      src: $setup.currentVideoUrl,
      controls: "",
      class: "video-player",
      onClick: _cache[0] || (_cache[0] = _withModifiers(function () {}, ["stop"]))
    }, null, 8, _hoisted_8)])) : _createCommentVNode("", true)]);
  }), 128)), _createElementVNode("span", _hoisted_9, _toDisplayString($setup.knowledgedetail.releaseDate), 1)]), _createVNode(_Transition, {
    name: "knowledgeRecommended",
    appear: "",
    class: "animate__animated",
    "enter-active-class": "animate__fadeInRight"
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_10, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.knowledgeRecommended, function (nr) {
        return _openBlock(), _createElementBlock("div", {
          class: "recommended",
          key: nr.id,
          onClick: function onClick($event) {
            return $setup.goRecommended(nr);
          }
        }, [_createElementVNode("img", {
          src: nr.imgUrl,
          alt: "公司新闻"
        }, null, 8, _hoisted_12), _createElementVNode("div", _hoisted_13, [_createElementVNode("p", _hoisted_14, _toDisplayString(nr.releaseDate), 1), _createElementVNode("h3", _hoisted_15, _toDisplayString(nr.title), 1)])], 8, _hoisted_11);
      }), 128)), _createElementVNode("button", {
        class: "backList",
        onClick: _cache[2] || (_cache[2] = function () {
          return $setup.backNewsList && $setup.backNewsList.apply($setup, arguments);
        })
      }, "返回列表")])];
    }),
    _: 1
  })])]);
}